module.exports = __webpack_public_path__ + "static/img/vertex-email.71a6aa48.png";